import React from 'react'
import styled from 'styled-components'
import classNames from 'classnames'
import { Card } from '@bootstrap-styled/v4'
import { unitUtils } from '@bootstrap-styled/utils'
import { remCalc } from '../../../styles/functions'
import { AppComponentStates, AppBrandColors } from '../../../typings/global'
import { omit } from 'ramda'

const { math } = unitUtils

// type definition
export type PanelProps = {
    hasForm?: boolean
    hasFilter?: boolean
    className?: string
    state?: AppComponentStates | Extract<AppBrandColors, 'primary'>
} & React.ComponentProps<typeof Card>

const Panel = styled(
    (attrs: PanelProps): JSX.Element => (
        <Card
            {...omit(
                ['hasFormPaddingX', 'hasFormPaddingY', 'hasForm', 'hasFilter', 'state'],
                attrs
            )}
        />
    )
).attrs(props => ({
    className: classNames(props.className, {
        'has-form': !!props.hasForm,
        'has-filter': !!props.hasFilter,
        [`card-state-${props.state}`]: !!props.state
    }),
    hasFormPaddingX: math.multiply(props.theme['$grid-gutter-width'], 2),
    hasFormPaddingY: props.theme['$grid-gutter-width']
}))`
    &.card .card-header {
        border-bottom: 2px solid ${props => props.theme['$primary']};
    }

    &.has-form {
        .card-header {
            position: relative;

            .role-thumbnail {
                position: absolute;
                top: 18px;
                left: 50%;
                transform: translate(-50%, 0px);
            }
        }
        .card-block {
            padding: ${props => remCalc(`80px ${props.hasFormPaddingX} ${props.hasFormPaddingY}`)};
        }
        .no-image-top {
            padding-top: ${props => props.theme['$spacers'][4]};
        }
    }

    &.has-filter {
        background-color: ${props => props.theme['$gray-lighter']};

        .card-block {
            padding: ${props => `${remCalc('20px')} ${props.theme['$spacer']}`};
        }

        .form-group {
            margin-bottom: ${props => props.theme['$spacer']};
        }
    }

    /* State colors */
    &.card-state-active {
        .card-header {
            border-bottom-color: ${props => props.theme['$green']};
        }
    }

    &.card-state-inactive {
        .card-header {
            border-bottom-color: ${props => props.theme['$strong-gray']};
        }
    }

    &.card-state-primary {
        .card-header {
            border-bottom-color: ${props => props.theme['$primary']};
        }
    }
`
export default Panel
